module.exports = __webpack_public_path__ + "static/img/ssr_9.0027a63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ssr_9.png
// module id = Q/r6
// module chunks = 16